// removed by extract-text-webpack-plugin
module.exports = {"tooltipLink":"_1vs7X","radioInput":"_21k0U","text":"_1zUnY","infoSection":"Xojft","label":"_1fyKd","licenseName":"_28skg _1zUnY","licenseDescription":"_2kOsB _1zUnY"};